<template>
	<div class="orders">
		<div v-if="orderData == 'load'" class="loading-animation"><div class="box"><span></span></div></div>
		<template v-else-if="orderData.length">
			<dl v-for="(obj, index) in orderData"
				:class="{
					open: (obj.open === undefined ? !index : obj.open),
					type1: obj.status == 'WAIT_BUYER_PAY' || obj.status == 'TRADE_NO_CREATE_PAY' || obj.status == 'WAIT_SELLER_SEND_GOODS' || obj.status == 'SELLER_CONSIGNED_PART' || obj.status == 'WAIT_BUYER_CONFIRM_GOODS' || obj.status == 'TRADE_BUYER_SIGNED',
					type2: obj.status == 'TRADE_FINISHED',
					type4: obj.status == 'TRADE_CLOSED' || obj.status == 'TRADE_CLOSED_BY_TAOBAO',
					'allow-edit-price': obj.status == 'WAIT_BUYER_PAY' || obj.status == 'TRADE_NO_CREATE_PAY'
				}"
			>
				<dt class="list-head head-info" @click="openOrFurl(obj, index)">
					<span>{{ obj.tid }}</span>
					<span class="time-box" v-html="new Date(obj.created).format('MM-dd hh:mm:ss')"></span>
					<span class="payment-status">
						<template v-if="obj.status == 'WAIT_BUYER_PAY'">待付款</template>
						<template v-else-if="obj.status == 'TRADE_CLOSED'">已关闭</template>
						<template v-else-if="obj.status == 'ALL_CLOSED'">所有关闭</template>
						<template v-else-if="obj.status == 'PAY_PENDING'">外卡支付</template>
						<template v-else-if="obj.status == 'ALL_WAIT_PAY'">所有买家</template>
						<template v-else-if="obj.status == 'TRADE_FINISHED'">已完成</template>
						<template v-else-if="obj.status == 'TRADE_BUYER_SIGNED'">已签收</template>
						<template v-else-if="obj.status == 'TRADE_NO_CREATE_PAY'">待付款</template>
						<template v-else-if="obj.status == 'WAIT_PRE_AUTH_CONFIRM'">0元购</template>
						<template v-else-if="obj.status == 'PAID_FORBID_CONSIGN'">禁止发货</template>
						<template v-else-if="obj.status == 'TRADE_CLOSED_BY_TAOBAO'">已关闭</template>
						<template v-else-if="obj.status == 'WAIT_SELLER_SEND_GOODS'">待发货</template>
						<template v-else-if="obj.status == 'SELLER_CONSIGNED_PART'">部分发货</template>
						<template v-else-if="obj.status == 'WAIT_BUYER_CONFIRM_GOODS'">已发货</template>
						<template v-else>未知状态</template>
					</span>
				</dt>
				<dd>
					<div class="head-info-aside">
						<p>
							<a href="javascript:;" class="edit-address" @click="$store.commit('changeOrderEditAddress', obj)">修改地址</a>
							<a href="javascript:;" class="ml-normal modify-mark" @click="wwImModifyMark(obj.tid)">备注</a>
							<a href="javascript:;" class="ml-normal" title="复制订单详情" @click="wwCopyOrder(obj)">复制</a>
						</p>
					</div>
					<div v-for="order in obj.orders.order" class="list-box clear">
						<a class="pic" :href="'https://item.taobao.com/item.htm?id=' + order.num_iid" target="_blank" :title="order.title">
							<img :src="order.pic_path" :alt="order.title">
						</a>
						<div class="content">
							<a class="title" :href="'https://item.taobao.com/item.htm?id=' + order.num_iid" target="_blank" :title="order.title">{{ order.title }}</a>
							<p class="info">{{ order.sku_properties_name }}</p>
						</div>
						<div class="right-box">
							<p class="price">
								￥<span v-show="!obj.showEditPrice" v-html="wwOrderPrice(order.price, order.adjust_fee, order.num)"></span>
								<input v-show="obj.showEditPrice" v-model="order.editPrice" type="text" value="">
							</p>
							<p>x<span>{{ order.num }}</span></p>
							<p>
								<span v-if="!order.refund_status" class="order-status" style="display: none">已取消</span>
								<template v-else-if="order.refund_status == 'WAIT_SELLER_AGREE'">申请退款</template>
								<template v-else-if="order.refund_status == 'WAIT_BUYER_RETURN_GOODS'">退款中</template>
								<template v-else-if="order.refund_status == 'WAIT_SELLER_CONFIRM_GOODS'">退货中</template>
								<template v-else-if="order.refund_status == 'SELLER_REFUSE_BUYER'">拒绝退款</template>
								<template v-else-if="order.refund_status == 'CLOSED'">退款关闭</template>
								<template v-else-if="order.refund_status == 'SUCCESS'">SUCCESS</template>
								<span class="order-status" style="display: none" v-else-if="order.refund_status == 'NO_REFUND'">已取消</span>
							</p>
						</div>
					</div>
					<div class="list-footer">
						共{{ obj.num }}件商品合计<span>{{ obj.payment }}</span>
						（运费
							<span v-show="!obj.showEditPrice">{{ obj.post_fee }}</span>
							<input v-show="obj.showEditPrice" v-model="obj.editPostFee" type="text" value="">
						）
						<a class="edit-price-btn" href="javascript:;" v-show="!obj.showEditPrice" @click="editPrice(obj)">一键改价</a>
						<p class="edit-price-btn-box" v-show="obj.showEditPrice">
							<a href="javascript:;" @click="saveEditPrice(obj)">保存</a>
							<a href="javascript:;" @click="cancelEditPrice(obj)">取消</a>
						</p>
					</div>
				</dd>
			</dl>
		</template>
		<p v-else class="shift">没有相关数据！</p>
		<orderMarkTpl></orderMarkTpl>
		<orderEditAddress></orderEditAddress>
	</div>
</template>

<script>
import orderMarkTpl from './orderMark.vue'
import orderEditAddress from './orderEditAddress.vue'
export default {
	name: 'orderTpl',
	data () {
		return {}
	},
	components: {
		'orderEditAddress': orderEditAddress,
		'orderMarkTpl': orderMarkTpl
	},
	computed: {
		orderData () {
			return this.$store.state.orderData;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	methods: {
		//旺旺价格计算
		wwOrderPrice (num1, num2, num3) {
			var k = parseFloat(num2) / parseFloat(num3),
				sq1, sq2, m;
			try {
				sq1 = parseFloat(num1).toString().split(".")[1].length;
			} catch (e) {
				sq1 = 0;
			}
			try {
				sq2 = parseFloat(k).toString().split(".")[1].length;
			} catch (e) {
				sq2 = 0;
			}
			m = Math.pow(10,Math.max(sq1, sq2));
			return (num1 * m + k * m) / m;
		},

		// 展开/收拢订单
		openOrFurl (obj, index) {
			var self = this;

			obj.open = (obj.open === undefined && !index) ? false : !obj.open;
			self.$forceUpdate();
		},

		// 一键复制订单详情
		wwCopyOrder (obj) {
			var self = this,
				content = '',
				state = obj.receiver_state ? (obj.receiver_state + '　') : '',
				city = obj.receiver_city ? (obj.receiver_city + '　') : '',
				district = obj.receiver_district ? (obj.receiver_district + '　') : '',
				address = obj.receiver_address ? (obj.receiver_address + '　') : '',
				zip = obj.receiver_zip ? (obj.receiver_zip + '　') : '',
				name = obj.receiver_name ? (obj.receiver_name + '　') : '',
				phone = obj.receiver_phone ? (obj.receiver_phone + '　') : '',
				mobile = obj.receiver_mobile ? (obj.receiver_mobile + '　') : '';

			content = state + city + district + address + zip + name + phone + mobile;

			self.$store.commit('changeSendContent', content);
			document.getElementsByClassName('ima_textarea')[0].focus();
		},
		
		// 获取备注信息
		wwImModifyMark (tid) {
			var self = this,
				data = {
					sessionId: self.currentConversation.id,
                    tid: tid
				};

			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/queryTradeOrderDetail', data).then(result => {
				if (result.code != 200) {
					alert('获取备注失败');
				}
			}, response => {
				alert('获取备注失败');
			})
		},

		// 一键改价
		editPrice (obj) {
			var self = this;

			obj.showEditPrice = true;
			obj.editPostFee = obj.post_fee;

			for (var i = 0; i < obj.orders.order.length; i++) {
				var order = obj.orders.order[i];
				order.editPrice = self.wwOrderPrice(order.price, order.adjust_fee, order.num);
			}
			self.$forceUpdate();
		},

		// 取消修改价格
		cancelEditPrice (obj) {
			var self = this;

			obj.showEditPrice = false;
			self.$forceUpdate();
		},

		// 保存改价
		saveEditPrice (obj) {
			var self = this,
				data = {
					tid: obj.tid,
					oids: obj.tid, // 每个商品的id(用,把每个商品的id连接起来)
					price: '', // 商品优惠/涨价总金额(用,把每个商品的数值连接起来)
					pricestr: [], // 每个商品的实收价格
					sessionId: self.currentConversation.id,
					psotage: parseFloat(obj.editPostFee).toFixed(2)
				};

			var temp_str = '';
			for (var i = 0; i < obj.orders.order.length; i++) {
				var order = obj.orders.order[i],
					originalSum = (order.price*order.num).toFixed(2), // 该商品按原价算的总金额
					actualSum = (order.editPrice*order.num).toFixed(2), // 该商品实际总金额
					floatSum = (parseFloat(actualSum) - parseFloat(originalSum)).toFixed(2);
					// 这个商品优惠或涨价的总额度

				data.pricestr.push(actualSum);
				data.price += (i ? ',' : '') + floatSum;
				temp_str += (i ? ',' : '') + order.oid;
			}
			if (temp_str) data.oids = temp_str;

			self.$axios.post(API_ROOT.baseUrl + '/api/wwim/updateOrderPrice', data).then(result => {
				self.$store.commit('changeOrderData', self.orderData);
				if (result.code != 200) {
					alert('改价失败');
				}
			}, response => {
				alert('改价失败');
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/order.vue